var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tip-info"},[_c('el-tooltip',{attrs:{"placement":_vm.placement}},[_c('div',{style:(_vm.computedStyle),attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2),_c('MaterialIcon',{attrs:{"size":_vm.size}},[_vm._v("help_outline")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }